import { render } from "./DoughnutChart.vue?vue&type=template&id=6217f864&scoped=true"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"

import "./DoughnutChart.vue?vue&type=style&index=0&id=6217f864&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6217f864"]])

export default __exports__